// extracted by mini-css-extract-plugin
module.exports = {"container":"errorStyles--container--1aJab","logo":"errorStyles--logo--1NiZ6","text":"errorStyles--text--oEVeh","inprogress":"errorStyles--inprogress--H8dJD"};